import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lk/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/lk/src/app/[locale]/(not-authorized)/account/password-recovery/components/PasswordRecovery/PasswordRecovery.tsx");
